// import React from "react";
// import "./EcomTwoComedy.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./EventOneComedy.scss";

const Comedy = () => {
  const options = {
    items: 3,
    dots: false,
    loop: true,
    margin: 30,
    nav: true,
    smartSpeed: 1500,
    autoplay: true,
    autoplayTimeout: 5000,
    responsive: {
      // Define breakpoints and the number of items to show at each breakpoint
      0: {
        items: 1,
        nav: false,
      },
      768: {
        items: 2,
        nav: false,
      },
      992: {
        items: 3,
      },
      1199: {
        items: 3,
      },
    },
  };
  return (
    <div className="Comedy-events">
      <div className="container">
        <div className="Comedy_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <span class="material-symbols-outlined">
                    sports_and_outdoors
                  </span>
                </div>
              </div>
              <div>
                <h2 className="title">Football</h2>
              </div>
            </div>
            <div className="right">
              <button className="event_one_viewall_button">View All</button>
            </div>
          </div>
          <div div className="event-container">
            <OwlCarousel className="owl-theme my_owl_carousel" {...options}>
              <div className="item event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/football1.jpg"
                    className="event-image"
                  />
                  <p>Indian Hero Trophy</p>
                  <div className="badge">SOCCER</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 May 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Chennai</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
              <div className="item event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/football2.jpg"
                    className="event-image"
                  />
                  <p>Inter Collge 2025</p>
                  <div className="badge">SOCCER</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 May 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Mumbai</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
              <div className="item event-card">
                <div className="image-container">
                  <img
                    src="./assets/img/eventify/football3.jpg"
                    className="event-image"
                  />
                  <p>Inter State Football Championship</p>
                  <div className="badge">SOCCER</div>
                </div>
                <div className="event-details">
                  <div className="text">
                    <span class="material-symbols-outlined">
                      calendar_month
                    </span>
                    <h6>1 May 2025</h6>
                  </div>
                  <div className="text">
                    <span class="material-symbols-outlined">location_on</span>
                    <h6>Delhi</h6>
                  </div>
                </div>
                <div className="buy-now">
                  <h6 className="price">₹499</h6>
                  <h6 className="buy_now">Buy now</h6>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comedy;
